export default __webpack_public_path__ + "static/media/Vector.80505f0b.svg";